// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","content":"form-header__content____WZR4h"};